import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import WhatsAppFab from "@/components/site/WhatsAppFab";

export default function Layout() {
  const { pathname } = useLocation();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    setReady(false);
    const t = setTimeout(() => setReady(true), 20);
    return () => clearTimeout(t);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-white text-brand-ink" data-testid="site-root">
      <Navbar />
      <main className={`flex-1 ${ready ? "animate-fade-up" : "opacity-0"}`}>
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
